import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from './../utils/route-guard/AuthGuard';

import Chats from '../views/pages/authentication/conversas/Chats3';

import AdministrationCenter from '../views/pages/authentication/configuracoes/geral/Administracao.js';
import ReorganizarMenu from '../views/pages/authentication/configuracoes/geral/ReorganizarMenu.js';

import BoardPipeline from '../views/pages/authentication/configuracoes/Negocios/index.js';

import FlowBuilder from '../views/pages/authentication/configuracoes/flows/FlowBuilder.js';

// Produtos: rota antiga (4 telas) aposentada na Fase B da unificação
// Produto+Serviço em Item, substituída por `ItemsPage.js` (mesmo padrão
// página+drawer do módulo de Serviços) - ver import mais abaixo, perto de
// `ServicosPage`/`TicketScreen`. Os arquivos antigos continuam no repo
// (não removidos), só não são mais roteados.

import ViewAllImoveis from '../views/pages/authentication/configuracoes/Imoveis/ViewAllImoveis.js';
import ViewImovel from '../views/pages/authentication/configuracoes/Imoveis/ViewImovel.js';
import EditImovel from '../views/pages/authentication/configuracoes/Imoveis/EditImovel.js';
import CreateImovel from '../views/pages/authentication/configuracoes/Imoveis/CreateImovel.js';

import ViewWhatsappTemplates from '../views/pages/authentication/configuracoes/whatsapp_templates/ViewWhatsappTemplates.js';
import ViewWhatsappInteractive from '../views/pages/authentication/configuracoes/whatsapp_interactive/ViewWhatsappInteractive.js';
import ViewDocumentos from '../views/pages/authentication/configuracoes/documentos/ViewDocumentos.js';

import Vendas from '../views/pages/authentication/configuracoes/vendas/index.js';
import DetalheVenda from '../views/pages/authentication/configuracoes/vendas/DetalheVenda.js';

import ChannelsPage from '../views/pages/authentication/configuracoes/channels/ChannelsPage.js';

import MessageChannels from '../views/pages/authentication/configuracoes/channels/ChannelsView.js';

import SystemApplications from '../views/pages/authentication/configuracoes/ajustes/AppViews.js';

import SystemUsers from '../views/pages/authentication/configuracoes/users/UsersSystem.js';

import SystemNotifications from '../views/pages/authentication/configuracoes/notifications/AdminNotification.js';

import SystemCustomization from '../views/pages/authentication/configuracoes/Customizacao/ViewCustmomization.js';

import Automations from '../views/pages/authentication/configuracoes/automacao/viewAutomation.js';

import ManageTeams from '../views/pages/authentication/configuracoes/equipes/ViewTeams.js';
import AttendanceHours from '../views/pages/authentication/configuracoes/agenda/AttendanceHours.js';

import MarketingCampaigns from '../views/pages/authentication/configuracoes/marketing/ViewMarketing.js';

import BusinessAdmin from '../views/pages/authentication/configuracoes/Negocios/ViewAdminDeals.js';

import CRMContacts from '../views/pages/authentication/configuracoes/contatos/ViewContacts.js';

import ViewUsers from '../views/pages/authentication/configuracoes/users/ViewUsers.js';
import CreateUser from '../views/pages/authentication/configuracoes/users/CreateUser.js';
import EditUser from '../views/pages/authentication/configuracoes/users/EditUser.js';

import CreateOrganization from '../views/pages/authentication/configuracoes/organizations/CreateOrganization.js';
import ViewOrganization from '../views/pages/authentication/configuracoes/organizations/ViewOrganization.js';
import EditOrganization from '../views/pages/authentication/configuracoes/organizations/EditOrganization.js';
import EnvioDocumentos from '../views/pages/authentication/configuracoes/organizations/EnvioDocumentos.js';
import CamposCustomizadosHub from '../views/pages/authentication/configuracoes/campos-customizados/CamposCustomizadosHub.js';

import ConfiguracoesConta from '../views/pages/authentication/configuracoes/conta/ConfiguracoesConta.js';

import ViewAgents from '../views/pages/authentication/configuracoes/agents/ViewAgents.js';
import ViewDetailAgents from '../views/pages/authentication/configuracoes/agents/DetailAgent.js';
import DetailActionTools from '../views/pages/authentication/configuracoes/agents/DetailActionTools.js';
import CreateAgent from '../views/pages/authentication/configuracoes/agents/CreateAgent.js';
import CreateTool from '../views/pages/authentication/configuracoes/agents/CreateTool.js';
import AgentTraces from '../views/pages/authentication/configuracoes/agents/AgentTraces.js';

import PipelineBoard from '../views/pages/pipeline/PipelineBoard.js';
import PipelineMain from '../views/pages/pipeline/PipelineMain.js';

import TicketScreen from '../views/pages/ticket/TicketsPage.js';
import ServicosPage from '../views/pages/servico/ServicosPage.js';
import ItemsHubPage from '../views/pages/item/ItemsHubPage.js';
import ItemFormPage from '../views/pages/item/ItemFormPage.js';

import SettingsControl from '../views/pages/authentication/configuracoes/index.js';
import Customization from '../layout/Customization/index.js';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('../views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('../views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('../views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('../views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('../views/utilities/TablerIcons')));
const CreateNewChannel = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/channels/ChannelsNew')));

const DisparosPage = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/disparos/DisparosPage.js')));
const DetalhesDisparo = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/disparos/DetalhesDisparo.js')));

const WelcomeDoc = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/docs/welcome.js')));
const HomeFlows = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/flows/HomeFlows.js')));
const Customizacao = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Customizacao/AjusteCustomizacao.js')));
const CalendarPage = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Calendar/CalendarPage.js')));
const DashboardDeals = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Dashboard/DashboardDeals.jsx')));
const ResumoPage = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Resumo/ResumoPage.jsx')));

const Reports = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/relatorios/VisualizarRelatorios.js')));

// const UtilsColor = Loadable(lazy(() => import('../views/utilities/Color'))); // Chats

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/sample-page')));

//-----------------------|| MAIN ROUTING ||-----------------------//
const MainRoutes = () => {
    const location = useLocation();

    return (
        <Route
            path={[
                '/dashboard/default',

                '/dashboard/chats',

                '/adm/config/',
                '/dashboard/admin/menu-order',

                '/utils/util-typography',
                '/utils/util-color',
                '/utils/util-shadow',
                '/icons/tabler-icons',
                '/icons/material-icons',

                '/dashboard/admin/apps',

                '/dashboard/admin/channels',

                '/dashboard/admin/automation',

                '/dashboard/admin/teams',
                '/dashboard/admin/attendance-hours',

                '/dashboard/marketing',

                '/dashboard/admin/deals',

                '/dashboard/admin/users',

                '/dashboard/admin/notifications',

                '/dashboard/contacts',

                '/dashboard/config/flows',
                '/dashboard/config/chatbots',

                '/dashboard/config/catalog',
                '/dashboard/config/new_catalog',
                '/dashboard/config/catalog_edit/:id',

                '/dashboard/config/imoveis',
                '/dashboard/config/imovel',
                '/dashboard/config/imovel/edit',
                '/dashboard/config/new/imovel',

                '/dashboard/config/whatsapp_templates',
                '/dashboard/config/whatsapp_interactive',

                '/dashboard/orders',
                '/dashboard/detailsorder',

                '/dashboard/config/channels',
                '/dashboard/config/new/channel',

                '/dashboard/config/shots',
                '/dashboard/disparo/',

                '/dashboard/config/conta',

                '/dashboard/config/agents/view',
                '/dashboard/config/agents/create',
                '/dashboard/config/agent',
                '/dashboard/config/detailagent',
                '/dashboard/config/toolsaction',
                '/dashboard/config/agent/tool/create',
                '/dashboard/config/agent/traces',

                '/dashboard/config/documentos',

                '/dashboard/config/organizations/create',
                '/dashboard/config/organizations/view',
                '/dashboard/config/organizations/edit',
                '/dashboard/config/organizations/envio-documentos',

                '/dashboard/config/users/create',
                '/dashboard/config/users/view',
                '/dashboard/config/users/edit',

                '/dashboard/config/custom-fields',

                '/dashboard/docs/welcome',

                '/dashboard/config/pipeline',

                '/dashboard/config/calendar',

                '/dashboard/config/tickets',

                '/dashboard/config/services',

                '/utils/util-report',

                '/dashboard/config/index/',

                '/dashboard/config/custom',

                '/dashboard/panel/',

                '/dashboard/resumo/',

                '/sample-page'
            ]}
        >
            <MainLayout>
                <Switch location={location} key={location.pathname}>
                    <AuthGuard>
                        <Route path="/dashboard/default" component={DashboardDefault} />
                        <Route path="/utils/util-typography" component={UtilsTypography} />
                        <Route path="/utils/util-color" component={UtilsColor} />
                        <Route path="/utils/util-shadow" component={UtilsShadow} />
                        <Route path="/icons/tabler-icons" component={UtilsTablerIcons} />
                        <Route path="/icons/material-icons" component={UtilsMaterialIcons} />
                        <Route path="/adm/config/" component={AdministrationCenter} />
                        <Route path="/dashboard/admin/menu-order" component={ReorganizarMenu} />
                        {/* <Route path="/dashboard/config/chats_negocio" component={BoardPipeline} /> */}

                        <Route path="/dashboard/chats" component={Chats} />

                        <Route path="/dashboard/admin/apps" component={SystemApplications} />

                        <Route path="/dashboard/admin/notifications" component={SystemNotifications} />

                        <Route path="/dashboard/admin/channels" component={MessageChannels} />

                        <Route path="/dashboard/contacts" component={CRMContacts} />

                        <Route path="/dashboard/admin/automation" component={Automations} />

                        <Route path="/dashboard/admin/teams" component={ManageTeams} />
                        <Route path="/dashboard/admin/attendance-hours" component={AttendanceHours} />

                        <Route path="/dashboard/marketing" component={MarketingCampaigns} />

                        <Route path="/dashboard/admin/deals" component={BusinessAdmin} />

                        {/* Chatbots */}
                        <Route path="/dashboard/config/chatbots" component={HomeFlows} />

                        {/* Catálogo unificado de Produtos/Serviços (Item) - grid + tela própria de criar/editar, sem Drawer */}
                        <Route path="/dashboard/config/new_catalog" component={ItemFormPage} />
                        <Route path="/dashboard/config/catalog_edit/:id" component={ItemFormPage} />
                        <Route path="/dashboard/config/catalog" component={ItemsHubPage} />

                        {/* IMÓVEIS */}
                        <Route path="/dashboard/config/imoveis" component={ViewAllImoveis} />
                        <Route path="/dashboard/config/imovel/edit/:id" component={EditImovel} />
                        <Route path="/dashboard/config/imovel/:id" component={ViewImovel} />
                        <Route path="/dashboard/config/new/imovel" component={CreateImovel} />

                        {/* WHATSAPP TEMPLATES */}
                        <Route path="/dashboard/config/whatsapp_templates" component={ViewWhatsappTemplates} />
                        <Route path="/dashboard/config/whatsapp_interactive" component={ViewWhatsappInteractive} />

                        {/* DOCUMENTOS */}
                        <Route path="/dashboard/config/documentos" component={ViewDocumentos} />

                        {/* VENDAS */}
                        <Route path="/dashboard/orders" component={Vendas} />
                        <Route path="/dashboard/detailsorder/:id" component={DetalheVenda} />

                        {/* Flows */}
                        <Route path="/dashboard/config/flows/edit/:id" component={FlowBuilder} />

                        {/* <Route path="/dashboard/config/flows/edit/:id" component={EditOrganization} /> */}
                        {/* Channels */}
                        <Route path="/dashboard/config/channels" component={ChannelsPage} />
                        <Route path="/dashboard/config/new/channel" component={CreateNewChannel} />

                        {/* Docs */}
                        <Route path="/dashboard/docs/welcome" component={WelcomeDoc} />

                        {/* Calendário */}
                        <Route path="/dashboard/config/calendar" component={CalendarPage} />

                        {/* Ajustes da Conta */}
                        <Route path="/dashboard/config/conta" component={ConfiguracoesConta} />

                        {/* Agents */}
                        <Route path="/dashboard/config/agents/view" component={ViewAgents} />
                        <Route path="/dashboard/config/agents/create" component={CreateAgent} />
                        <Route path="/dashboard/config/detailagent/:id" component={ViewDetailAgents} />
                        <Route path="/dashboard/config/agent/tool/create/:agentId" component={CreateTool} />
                        <Route path="/dashboard/config/agent/tool/:toolId" component={DetailActionTools} />
                        <Route path="/dashboard/config/agent/traces/:agentId" component={AgentTraces} />

                        {/* Organization */}
                        <Route path="/dashboard/config/organizations/create" component={CreateOrganization} />
                        <Route path="/dashboard/config/organizations/view" component={ViewOrganization} />
                        <Route path="/dashboard/config/organizations/edit/:id" component={EditOrganization} />
                        <Route path="/dashboard/config/organizations/envio-documentos" component={EnvioDocumentos} />

                        {/* Users */}

                        <Route path="/dashboard/admin/users" component={SystemUsers} />
                        <Route path="/dashboard/config/users/view/" component={ViewUsers} />
                        <Route path="/dashboard/config/users/create/" component={CreateUser} />
                        <Route path="/dashboard/config/users/edit/:id" component={EditUser} />

                        {/* Campos Customizados (Clientes/Empresas/Negócios/Produtos/Eventos) */}
                        <Route path="/dashboard/config/custom-fields" component={CamposCustomizadosHub} />

                        {/* Deals */}
                        <Route path="/dashboard/config/pipeline" component={PipelineMain} />

                        {/* Dashboard */}
                        <Route path="/dashboard/panel/" component={DashboardDeals} />

                        {/* Resumo (IA) - dashboard + chat */}
                        <Route path="/dashboard/resumo/" component={ResumoPage} />

                        {/* Relatórios */}
                        <Route path="/utils/util-report" component={Reports} />

                        {/* Tickets */}
                        <Route path="/dashboard/config/tickets" component={TicketScreen} />

                        {/* Serviços */}
                        <Route path="/dashboard/config/services" component={ServicosPage} />
                        <Route path="/dashboard/config/shots" component={DisparosPage} />
                        <Route path="/dashboard/disparo/:id" component={DetalhesDisparo} />
                        <Route path="/dashboard/config/index/" component={SettingsControl} />

                        {/* Customization */}
                        <Route path="/dashboard/config/custom/" component={Customizacao} />
                        <Route path="/sample-page" component={SamplePage} />
                        {/* <Route path="/dashboard/config/custom" component={SystemCustomization} /> */}
                    </AuthGuard>
                </Switch>
            </MainLayout>
        </Route>
    );
};

export default MainRoutes;
